
import {Howl, Howler} from './Howler.js';

export default class DeviceOrientationChecker {
    constructor(deviceManager, isLandscape, rootElement){     	
        this.isValidOrientation = false;

        this.isLandscape = isLandscape;

        this.deviceManager = deviceManager;

        this.game = null;

        this.rotateElement = document.createElement('div');
        this.rotateElement.id = 'rotate-screen';
        this.rotateElement.className = 'hidden';
        this.rotateElement.style.textIndent = '-100%';
        this.rotateElement.innerHTML = 'please rotate your device';
        
        rootElement.appendChild(this.rotateElement);

        this.onValidOrientation = null;

        window.addEventListener("resize", this.OnResize.bind(this));
        window.addEventListener("orientationchange", this.CheckOrientation.bind(this));
        
    }

    CheckOrientation() {
        let wasValidOrientation = this.isValidOrientation;
        this.isValidOrientation = this.deviceManager.desktop || (this.isLandscape ? window.innerWidth > window.innerHeight : window.innerWidth < window.innerHeight);

        this.rotateElement.className = this.isValidOrientation ? 'hidden' : 'visible';

        if(this.isValidOrientation){
            //Fire function
            if(this.onValidOrientation){
                this.onValidOrientation.call();
            }
        }
        
        if(this.game && wasValidOrientation != this.isValidOrientation){
            if(this.isValidOrientation){
                this.ResumeAllScenes();
            }
            else{
                this.PauseAllScenes();
            }
        }
    }

    PauseAllScenes(){
        for(var key in this.game.scene.keys){
            var scene = this.game.scene.getScene(key);
            scene.sound.pauseAll();
            Howler.mute(true);
            this.game.scene.pause(key);
        }
    }

    ResumeAllScenes(){
        for(var key in this.game.scene.keys){
            var scene = this.game.scene.getScene(key);
            scene.sound.resumeAll();
            Howler.mute(false);
            this.game.scene.resume(key);
        }
    }
    
    OnResize() {
        setTimeout(function(){
            this.Resize();
        }.bind(this),50);
        //this.Resize();
    }
    
    Resize() {
        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;
        this.rotateElement.style.width = windowWidth + "px";
        this.rotateElement.style.height = windowHeight + "px";
    
        this.CheckOrientation();
    }
    
}